import dayjs from 'dayjs'
import XLSX from 'xlsx-js-style' 
import { lightyellow, lightblue, lightpurple, lightpink, lightgrey, editDateForExcel } from '@/utils/excel'

export const ExportExcel = async (jsonData: any[], masterData: any) => {
    const {
        masterTransferPlanType,
        masterInspectionTransfer
    } = masterData

    const reportExcel = jsonData.map(x => {
        let newJson = {} as any
        newJson[`ยูนิต`] = x.unitCode
        newJson[`สถานะการขาย`] = x.saleStatus
        newJson[`โมเดล`] = x.model
        newJson[`พื้นที่ (M2/W2)`] = x.area
        newJson[`ราคาต่อ ตรม./ตรว.`] = x.areaValue
        newJson[`บ้านเลขที่`] = x.address
        newJson[`ชื่อลูกค้า`] = x.customerName
        newJson[`VIP`] = x.vipStatus
        newJson[`เบอร์โทรศัพท์`] = x.mobilePhone
        newJson[`อีเมล`] = x.email
        newJson[`ราคาตามสัญญา`] = x.contractUnitPrice == '0' ? "" : parseInt(x.contractUnitPrice)
        newJson[`ราคาสุทธิ`] = x.netPrice == '0' ? "" : parseInt(x.netPrice)
        newJson[`คะแนน QC ครั้งล่าสุด`] = x.qcInspection ?? ""
        newJson[`สถานะ QC ครั้งล่าสุด`] = x.qcStatus ?? ""
        newJson[`ประเภทการเข้าตรวจ`] = masterTransferPlanType.filter((m: any) => m.id == x.transferPlanTypeId)[0].name
        newJson[`วันที่ CR ระบุในจดหมายเชิญตรวจ(กรณีเข้าตรวจหลังโอน)`] = x.inspectionAfterTransferDate == "" ? "" : editDateForExcel(dayjs(x.inspectionAfterTransferDate).format("DD/MM/YYYY"))
        newJson[`วันที่ PJ Plan แล้วเสร็จ(กรณีเข้าตรวจหลังโอน)`] = x.planPJAfterTransferDate == "" ? "" : editDateForExcel(dayjs(x.planPJAfterTransferDate).format("DD/MM/YYYY") )
        newJson[`สถานะการโอน`] = x.transferStatus
        newJson[`วันที่ CR ระบุในการ์ดเชิญตรวจ`] = x.letterPlanforCR == "" ? "" : editDateForExcel(dayjs(x.letterPlanforCR).format("DD/MM/YYYY")
)
        newJson[`Plan PJ พร้อมให้เข้าตรวจ#1`] = x.inspection1PlanPJDate == "" ? "" : editDateForExcel(dayjs(x.inspection1PlanPJDate).format("DD/MM/YYYY"))
        newJson[`วันเก็บงานเสร็จพร้อมตรวจ#1`] = x.inspection1FinishPJDate == "" ? "" : editDateForExcel(dayjs(x.inspection1FinishPJDate).format("DD/MM/YYYY"))
        newJson[`วันที่ CR นัดได้#1`] = x.inspection1PlanCRDate == "" ? "" : editDateForExcel(dayjs(x.inspection1PlanCRDate).format("DD/MM/YYYY"))
        newJson[`เวลาที่ CR นัดได้#1`] = x.inspection1PlanCRTime

        newJson[`ชื่อบริษัทรับตรวจบ้าน`] = x.inspectorName

        newJson[`วันที่ลูกค้าเข้าตรวจจริง#1`] = x.inspection1CustomerDate == "" ? "" : editDateForExcel(dayjs(x.inspection1CustomerDate).format("DD/MM/YYYY"))
        newJson[`สถานะการรับมอบ#1`] = masterInspectionTransfer.filter((m: any) => m.id == x.inspection1TypeID)[0].name

        newJson[`Plan PJ พร้อมให้เข้าตรวจ#2`] = x.inspection2PlanPJDate == "" ? "" : editDateForExcel(dayjs(x.inspection2PlanPJDate).format("DD/MM/YYYY"))
        newJson[`วันเก็บงานเสร็จพร้อมตรวจ#2`] = x.inspection2FinishPJDate == "" ? "" : editDateForExcel(dayjs(x.inspection2FinishPJDate).format("DD/MM/YYYY"))
        newJson[`วันที่ CR นัดได้#2`] = x.inspection2PlanCRDate == "" ? "" : editDateForExcel(dayjs(x.inspection2PlanCRDate).format("DD/MM/YYYY"))
        newJson[`เวลาที่ CR นัดได้#2`] = x.inspection2PlanCRTime 
        newJson[`วันที่ลูกค้าเข้าตรวจจริง#2`] = x.inspection2CustomerDate == "" ? "" : editDateForExcel(dayjs(x.inspection2CustomerDate).format("DD/MM/YYYY"))
        newJson[`สถานะการรับมอบ#2`] = masterInspectionTransfer.filter((m: any) => m.id == x.inspection2TypeID)[0].name

        newJson[`Plan PJ พร้อมให้เข้าตรวจ#3`] = x.inspection3PlanPJDate == "" ? "" : editDateForExcel(dayjs(x.inspection3PlanPJDate).format("DD/MM/YYYY"))
        newJson[`วันเก็บงานเสร็จพร้อมตรวจ#3`] = x.inspection3FinishPJDate == "" ? "" : editDateForExcel(dayjs(x.inspection3FinishPJDate).format("DD/MM/YYYY"))
        newJson[`วันที่ CR นัดได้#3`] = x.inspection3PlanCRDate == "" ? "" : editDateForExcel(dayjs(x.inspection3PlanCRDate).format("DD/MM/YYYY"))
        newJson[`เวลาที่ CR นัดได้#3`] = x.inspection3PlanCRTime
        newJson[`วันที่ลูกค้าเข้าตรวจจริง#3`] = x.inspection3CustomerDate == "" ? "" : editDateForExcel(dayjs(x.inspection3CustomerDate).format("DD/MM/YYYY"))
        newJson[`สถานะการรับมอบ#3`] = masterInspectionTransfer.filter((m: any) => m.id == x.inspection3TypeID)[0].name

        newJson[`Plan PJ พร้อมให้เข้าตรวจ#4`] = x.inspection4PlanPJDate == "" ? "" : editDateForExcel(dayjs(x.inspection4PlanPJDate).format("DD/MM/YYYY"))
        newJson[`วันเก็บงานเสร็จพร้อมตรวจ#4`] = x.inspection4FinishPJDate == "" ? "" : editDateForExcel(dayjs(x.inspection4FinishPJDate).format("DD/MM/YYYY"))
        newJson[`วันที่ CR นัดได้#4`] = x.inspection4PlanCRDate == "" ? "" : editDateForExcel(dayjs(x.inspection4PlanCRDate).format("DD/MM/YYYY"))
        newJson[`เวลาที่ CR นัดได้#4`] = x.inspection4PlanCRTime
        newJson[`วันที่ลูกค้าเข้าตรวจจริง#4`] = x.inspection4CustomerDate == "" ? "" : editDateForExcel(dayjs(x.inspection4CustomerDate).format("DD/MM/YYYY"))
        newJson[`สถานะการรับมอบ#4`] = masterInspectionTransfer.filter((m: any) => m.id == x.inspection4TypeID)[0].name
        newJson[`สรุปสถานะห้อง`] = x.summaryRoomStatus

        newJson[`CR Note(สำหรับการนัดตรวจ)`] = x.crNote
        newJson[`PJ Note`] = x.pjNote

        newJson[`วันที่ CR/PJ นัดได้ล่าสุด`] = x.finalCRPlanDate == "" ? "" : editDateForExcel(dayjs(x.finalCRPlanDate).format("DD/MM/YYYY"))
        newJson[`เวลาที่ CR/PJ นัดได้ล่าสุด`] = x.finalCRPlanTime
        newJson[`ครั้งที่นัดตรวจล่าสุด`] = x.finalInspection
        newJson[`วันที่ลูกค้ารับมอบ`] = x.customerTransferReal == "" ? "" : editDateForExcel(dayjs(x.customerTransferReal).format("DD/MM/YYYY"))
        newJson[`CR Plan`] = x.csPlanDate == "" ? "" : editDateForExcel(dayjs(x.csPlanDate).format("DD/MM/YYYY"))
        newJson[`วันที่โอนจริง`] = x.transferActDate == "" ? "" : editDateForExcel(dayjs(x.transferActDate).format("DD/MM/YYYY"))
        newJson[`สรุปวันโอน(Plan+Actual)`] = x.finalActualDate == "" ? "" : editDateForExcel(dayjs(x.finalActualDate).format("DD/MM/YYYY"))
        newJson[`CR ที่รับผิดชอบ`] = x.crName
        
        return newJson
    })

    const dataWS = XLSX.utils.json_to_sheet(reportExcel,  {dateNF: "dd/MM/yyyy" })
        const wb = XLSX.utils.book_new()
            
        const headerCells = [
            "A1", "B1", "C1", "D1", "E1", 
            "F1", "G1", "H1", "I1", "J1", 
            "K1", "L1", "M1", "N1", "O1", 
            "P1", "Q1", "R1", "S1", "T1",
            "U1", "V1", "W1", "X1", "Y1",
            "Z1", "AA1", "AB1", "AC1", "AD1",
            "AE1", "AF1", "AG1", "AH1", "AI1",
            "AJ1", "AK1", "AL1", "AM1", "AN1",
            "AO1", "AP1", "AQ1", "AR1", "AS1",
            "AT1", "AU1", "AV1", "AW1", "AX1",
            "AY1", "AZ1","BA1","BB1","BC1"
        ]

        for (let index = 0; index < headerCells.length; index++) {
            const element = headerCells[index]
            dataWS[`${element}`].s = {
                font: {
                    sz: 11,
                    bold: true,
                },
                fill: { 
                    patternType: "solid",
                    fgColor: { rgb: "FFE5E5E5" },
                },
                border: {
                    top: { style: "thin", color: { auto: 1 } },
                    right: { style: "thin", color: { auto: 1 } },
                    bottom: { style: "thin", color: { auto: 1 } },
                    left: { style: "thin", color: { auto: 1 } }
                }
            }
        }

        for (let index = 1; index <= reportExcel.length; index++) {

            dataWS[`K${index+1}`].s = {
                alignment: {
                    horizontal: "right"
                }
            }

            dataWS[`L${index+1}`].s = {
                alignment: {
                    horizontal: "right"
                }
            }

            dataWS[`A${index+1}`].s = lightgrey
            dataWS[`F${index+1}`].s = lightpink
            //dataWS[`N${index+1}`].s =  lightgrey
            dataWS[`O${index+1}`].s =  lightblue
            dataWS[`P${index+1}`].s =  lightyellow
            dataWS[`Q${index+1}`].s =  lightblue
            dataWS[`R${index+1}`].s =  lightpurple
            dataWS[`S${index+1}`].s =  lightblue
            dataWS[`T${index+1}`].s =  lightyellow
            dataWS[`U${index+1}`].s =  lightyellow
            dataWS[`V${index+1}`].s =  lightyellow
            dataWS[`W${index+1}`].s =  lightyellow
            dataWS[`X${index+1}`].s =  lightyellow
            dataWS[`Y${index+1}`].s =  lightyellow
            dataWS[`Z${index+1}`].s =  lightyellow
            dataWS[`AA${index+1}`].s = lightblue
            dataWS[`AB${index+1}`].s = lightblue
            dataWS[`AC${index+1}`].s = lightblue
            dataWS[`AD${index+1}`].s = lightblue
            dataWS[`AE${index+1}`].s = lightblue
            dataWS[`AF${index+1}`].s = lightblue
            dataWS[`AG${index+1}`].s = lightblue
            dataWS[`AH${index+1}`].s = lightblue
            dataWS[`AI${index+1}`].s = lightblue
            dataWS[`AJ${index+1}`].s = lightblue
            dataWS[`AK${index+1}`].s = lightblue
            dataWS[`AL${index+1}`].s = lightblue
            dataWS[`AM${index+1}`].s = lightblue
            dataWS[`AN${index+1}`].s = lightblue
            dataWS[`AO${index+1}`].s = lightblue
            dataWS[`AP${index+1}`].s = lightblue
            dataWS[`AQ${index+1}`].s = lightblue
            dataWS[`AR${index+1}`].s = lightblue
            dataWS[`AS${index+1}`].s = lightyellow
            dataWS[`AT${index+1}`].s = lightblue
            dataWS[`AU${index+1}`].s = lightgrey
            dataWS[`AV${index+1}`].s = lightgrey
            dataWS[`AW${index+1}`].s = lightgrey
            dataWS[`AX${index+1}`].s = lightgrey
            dataWS[`AY${index+1}`].s = lightyellow
            dataWS[`AZ${index+1}`].s = lightgrey
            dataWS[`BA${index+1}`].s = lightgrey
            dataWS[`BB${index+1}`].s = lightyellow
            dataWS[`BC${index+1}`].s = lightyellow
        }

        let nCols = 1
    for (const key in reportExcel) {
        nCols++
        dataWS[`K${nCols}`].z = "#,##0"
        dataWS[`L${nCols}`].z = "#,##0"
        //วันที่ CR ระบุในจดหมายเชิญตรวจ(กรณีเข้าตรวจหลังโอน)
        dataWS[`O${nCols}`].t = "n"
        dataWS[`O${nCols}`].z = "dd/MM/yyyy"
        //วันที่ PJ Plan แล้วเสร็จ(กรณีเข้าตรวจหลังโอน)
        dataWS[`P${nCols}`].t = "n"
        dataWS[`P${nCols}`].z = "dd/MM/yyyy"
        //วันที่ CR ระบุในการ์ดเชิญตรวจ
        dataWS[`R${nCols}`].t = "n"
        dataWS[`R${nCols}`].z = "dd/MM/yyyy"
        //Plan PJ พร้อมให้เข้าตรวจ#1
        dataWS[`S${nCols}`].t = "n"
        dataWS[`S${nCols}`].z = "dd/MM/yyyy"
        //วันเก็บงานเสร็จพร้อมตรวจ#1
        dataWS[`T${nCols}`].t = "n"
        dataWS[`T${nCols}`].z = "dd/MM/yyyy"
        //วันที่ CR นัดได้#1
        dataWS[`U${nCols}`].t = "n"
        dataWS[`U${nCols}`].z = "dd/MM/yyyy"
        //วันที่ลูกค้าเข้าตรวจจริง#1
        dataWS[`W${nCols}`].t = "n"
        dataWS[`W${nCols}`].z = "dd/MM/yyyy"
        //Plan PJ พร้อมให้เข้าตรวจ#2
        dataWS[`Y${nCols}`].t = "n"
        dataWS[`Y${nCols}`].z = "dd/MM/yyyy"
        //วันเก็บงานเสร็จพร้อมตรวจ#2
        dataWS[`Z${nCols}`].t = "n"
        dataWS[`Z${nCols}`].z = "dd/MM/yyyy"
        //วันที่ CR นัดได้#2
        dataWS[`AA${nCols}`].t = "n"
        dataWS[`AA${nCols}`].z = "dd/MM/yyyy"
        //วันที่ลูกค้าเข้าตรวจจริง#2
        dataWS[`AC${nCols}`].t = "n"
        dataWS[`AC${nCols}`].z = "dd/MM/yyyy"
        //Plan PJ พร้อมให้เข้าตรวจ#3
        dataWS[`AE${nCols}`].t = "n"
        dataWS[`AE${nCols}`].z = "dd/MM/yyyy"
        //วันเก็บงานเสร็จพร้อมตรวจ#3
        dataWS[`AF${nCols}`].t = "n"
        dataWS[`AF${nCols}`].z = "dd/MM/yyyy"
        //วันที่ CR นัดได้#3
        dataWS[`AG${nCols}`].t = "n"
        dataWS[`AG${nCols}`].z = "dd/MM/yyyy"
        //วันที่ลูกค้าเข้าตรวจจริง#3
        dataWS[`AI${nCols}`].t = "n"
        dataWS[`AI${nCols}`].z = "dd/MM/yyyy"
        //Plan PJ พร้อมให้เข้าตรวจ#4
        dataWS[`AK${nCols}`].t = "n"
        dataWS[`AK${nCols}`].z = "dd/MM/yyyy"
        //วันเก็บงานเสร็จพร้อมตรวจ#4
        dataWS[`AL${nCols}`].t = "n"
        dataWS[`AL${nCols}`].z = "dd/MM/yyyy"
        //วันที่ CR นัดได้#4
        dataWS[`AM${nCols}`].t = "n"
        dataWS[`AM${nCols}`].z = "dd/MM/yyyy"
        //วันที่ลูกค้าเข้าตรวจจริง#4
        dataWS[`AO${nCols}`].t = "n"
        dataWS[`AO${nCols}`].z = "dd/MM/yyyy"
        //วันที่ CR/PJ นัดได้ล่าสุด
        dataWS[`AV${nCols}`].t = "n"
        dataWS[`AV${nCols}`].z = "dd/MM/yyyy"
        //ครั้งที่ตรวจล่าสุด
        dataWS[`AX${nCols}`].t = "n"
        dataWS[`AX${nCols}`].z = "dd/MM/yyyy"
        //วันที่ลูกค้ารับมอบ
        dataWS[`AY${nCols}`].t = "n"
        dataWS[`AY${nCols}`].z = "dd/MM/yyyy"
        //CR Plan
        dataWS[`AZ${nCols}`].t = "n"
        dataWS[`AZ${nCols}`].z = "dd/MM/yyyy"
        //วันที่โอนจริง
        dataWS[`BA${nCols}`].t = "n"
        dataWS[`BA${nCols}`].z = "dd/MM/yyyy"
        //สรุปวันโอน(Plan+Actual)
        dataWS[`AY${nCols}`].t = "n"
        dataWS[`AY${nCols}`].z = "dd/MM/yyyy"
    }
            
        let wscols = [ 
            { wch:14 }, 
            { wch:7 }, 
            { wch:10 }, 
            { wch:12 }, 
            { wch:16 }, 
            { wch:13 }, 
            { wch:60}, 
            { wch:15 }, 
            { wch:20 }, 
            { wch:40 }, 
            { wch:20 }, 
            { wch:20 }, 
            { wch:20 }, 
            { wch:18 }, 
            { wch:34 }, 
            { wch:43 }, 
            { wch:35 }, 
            { wch:12 }, 
            { wch:25 }, 
            { wch:23 }, 
            { wch:23 }, 
            { wch:15 }, 
            { wch:15 }, 

            { wch:40 },

            { wch:20 }, 
            { wch:16 }, 
            { wch:21 }, 
            { wch:22 }, 
            { wch:22 }, 
            { wch:20 }, 
            { wch:20 }, 
            { wch:21 }, 
            { wch:22 }, 
            { wch:22 }, 
            { wch:22 }, 
            { wch:20 }, 
            { wch:20 }, 
            { wch:21 }, 
            { wch:22 }, 
            { wch:22 }, 
            { wch:22 }, 
            { wch:20 }, 
            { wch:20 }, 
            { wch:21 }, 
            { wch:40 }, 
            { wch:40 }, 
            { wch:25 }, 
            { wch:25 }, 
            { wch:18 }, 
            { wch:18 }, 
            { wch:15 }, 
            { wch:15 }, 
            { wch:23 }, 
            { wch:40 }, 
            { wch:30 }, 
            
        ];
        dataWS['!cols'] = wscols
        XLSX.utils.book_append_sheet(wb, dataWS)
        XLSX.writeFile(wb,`TransferPJ-${splitProjectCode(jsonData[0].unitCode)}-${dayjs().format("DD-MM-YYYY")}.xlsx`)
}

const splitProjectCode = (data: string) => {
    if (data != "") {
        const [ project, unit ] = data.split("-")
        return `${project}`
    }
    return ""
}